<template>
  <div>
    <b-table show-empty striped hover class="aco-table"
             :sort-by.sync="paging.sortBy" :sort-desc.sync="paging.sortDesc" sort-icon-left no-local-sorting @sort-changed="changeSortBy"
             :busy="loading"
             :items="licenses"
             :fields="usageFields">
      <template #table-busy>
        <div class="text-center">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template slot="empty">
        <div class="text-center">{{ $t('noResults') }}</div>
      </template>

      <template v-slot:cell(organizationName)="row">
        <span v-if="row.item.organizationName">{{ row.item.organizationName }}</span>
        <span v-else><i>{{ row.item.ownerOrganizationNumber }}</i></span>
      </template>

      <template v-slot:cell(faktiskBruk)="row">
        <span v-if="usageCounts[row.item.licenseId] == null">
          <b-spinner small/>
        </span>
        <span v-else>
          {{ usageCounts[row.item.licenseId] }}
          <b-badge v-if="isOverused(row.item)" variant="danger" class="ml-1">
            {{ $t('overuse') }}
          </b-badge>
        </span>
      </template>

      <template v-slot:cell(totaltBruk)="row">
        <span v-if="totalUsageCounts[row.item.licenseId] == null">
          <b-spinner small/>
        </span>
        <span v-else>
          {{ totalUsageCounts[row.item.licenseId] }}
          <b-badge v-if="isMerforbruk(row.item)" variant="warning" class="ml-1">
            {{ $t('excessUsage') }}
          </b-badge>
        </span>
      </template>

      <template v-slot:cell(show_details)="row">
        <b-button size="sm" class="py-0" @click="openDetails(row.item)">{{ $t('details') }}</b-button>
      </template>
    </b-table>

    <usage-details ref="usageDetailsModal" :license="selectedLicense"
                   :actual-usage="selectedLicense && usageCounts[selectedLicense.licenseId]"/>
  </div>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'
  import UsageDetails from './UsageDetails'

  export default {
    name: 'UsageList',
    extends: BaseComponent,
    components: { UsageDetails },

    data: () => ({
      selectedLicense: null,
    }),

    created () {
      this.$store.dispatch('usage/getLicenses')
    },

    computed: {
      ...mapGetters('usage', ['paging', 'licenses', 'usageCounts', 'totalUsageCounts', 'loading']),
      usageFields () {
        return [
          { key: 'ownerOrganizationNumber', label: this.$t('organizationNumber') },
          { key: 'organizationName', label: this.$t('schoolName') },
          { key: 'ean', label: this.$t('ean_isbn') },
          { key: 'productName', label: this.$t('name'), sortable: true },
          { key: 'usageRights', label: this.$t('purchasedLicenses') },
          { key: 'faktiskBruk', label: this.$t('actualUsage') },
          { key: 'totaltBruk', label: this.$t('totalUsage') },
          { key: 'show_details', label: '' }
        ]
      }
    },
    methods: {
      changeSortBy (sort) {
        if (sort.sortBy) {
          this.$store.dispatch('usage/updatePaging', {
            sortBy: sort.sortBy,
            sortDesc: sort.sortDesc
          })
        }
      },
      isOverused (item) {
        const count = this.usageCounts[item.licenseId]
        return count != null && count > item.usageRights
      },
      isMerforbruk (item) {
        const count = this.totalUsageCounts[item.licenseId]
        return count != null && count > item.usageRights
      },
      openDetails (license) {
        this.selectedLicense = license
        this.$nextTick(() => {
          this.$root.$emit('bv::show::modal', 'usageDetailsModal')
        })
      },
    },
  }
</script>
